import { useState, useRef, useEffect } from 'react';
import { FaCaretRight, FaCaretDown } from 'react-icons/fa';
import { Label } from '../input';

export const Collapsible = ({ label, value, children }) => {
  const [open, setOpen] = useState();
  const prevValueRef = useRef();

  useEffect(() => {
    if (value && !prevValueRef.current) {
      setOpen(true);
    }

    prevValueRef.current = value;
  }, [value]);

  const caretStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    cursor: 'pointer',
  };

  const borderStyle = {
    border: '1px solid #ddd',
    borderRadius: 8,
    padding: 8,
  };

  if (!open) {
    return (
      <div style={{ ...borderStyle, ...caretStyle, width: '100%' }} onClick={() => setOpen(true)}>
        <FaCaretRight />
        <Label label={label} />
      </div>
    );
  } else {
    return (
      <div style={{ ...borderStyle, width: '100%' }}>
        <div style={{ ...caretStyle }} onClick={() => setOpen(false)}>
          <FaCaretDown />
          <Label label={label} />
        </div>
        {children}
      </div>
    );
  }
};
